import { useState, useEffect } from "react";
import styles from "./index.module.scss";
import { getTime } from "../../../utils/common.utils";
import { isMobileDevice } from "../../../utils/getPlatformInfo";

const AnouncementTime = ({ data }) => {
  const [durationObj, setDurationObj] = useState({});
  useEffect(() => {
    var interval = null;
    if (data) {
      interval = setInterval(() => {
        setDurationObj(getTime(data.timestamp.seconds * 1000, interval));
      }, 1000);
     setDurationObj(getTime(data.timestamp.seconds * 1000, interval));
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [data]);
  if (isNaN(durationObj?.s) || durationObj?.s < 0) {
    return null;
  }

  return (
    <div className={styles.timerContainer}>
      <div className={styles.strtsInText}>Starts In</div>
      <div className={styles.timer}>
        {durationObj?.d ? (
          <>
            <div className={styles.timeValue}>
              <span>{durationObj.d || 0}</span>
              <div className={styles.smallInfo}>
                {isMobileDevice
                  ? "d:"
                  : durationObj.d && durationObj.d == 1
                  ? "Day"
                  : "Days"}
              </div>
            </div>
            <div className={styles.timeValue}>
              <span>{durationObj.h || 0}</span>
              <div className={styles.smallInfo}>
                {isMobileDevice
                  ? "h"
                  : durationObj.h && durationObj.h == 1
                  ? "Hour"
                  : "Hours"}
              </div>
            </div>
          </>
        ) : durationObj?.h > 0 ? (
          <>
            <div className={styles.timeValue}>
              <span>{durationObj.h || 0}</span>
              <div className={styles.smallInfo}>
                {isMobileDevice
                  ? "h"
                  : durationObj.h && durationObj.h == 1
                  ? "Hour"
                  : "Hours"}
              </div>
            </div>
            <div className={styles.timeValue}>
              <span>{durationObj.m || 0}</span>
              <div className={styles.smallInfo}>
                {isMobileDevice
                  ? "m"
                  : durationObj.m && durationObj.m == 1
                  ? "Minute"
                  : "Minutes"}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={styles.timeValue}>
              <span>{durationObj.m || 0}</span>
              <div className={styles.smallInfo}>
                {isMobileDevice
                  ? "m"
                  : durationObj.m && durationObj.m == 1
                  ? "Minute"
                  : "Minutes"}
              </div>
            </div>
            <div className={styles.timeValue}>
              <span>{durationObj.s || 0}</span>
              <div className={styles.smallInfo}>
                {isMobileDevice
                  ? "s"
                  : durationObj.s && durationObj.s == 1
                  ? "Second"
                  : "Seconds"}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AnouncementTime;
